var disposed = false
var normalizeComponent = require("!../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SPDH.vue"
import __vue_script__ from "!!babel-loader!../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SPDH.vue"
/* template */
import __vue_template__ from "!!../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-bea10f92\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SPDH.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/SPDH/SPDH.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bea10f92", Component.options)
  } else {
    hotAPI.reload("data-v-bea10f92", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/SPDH/SPDH.vue
// module id = null
// module chunks = 